import React from 'react';
import { useGetStockMaterialPartQuery } from 'thunks/RTKQuery/parts';
import { Table } from 'components/Table';
import { Spinner2 } from 'components';
import { detailsColumns } from './detailsColumns';

interface PartsDetailViewProps {
  partId: number;
}

export const PartsDetailView = ({ partId }: PartsDetailViewProps) => {
  const { data: stockMaterialParts, isLoading } = useGetStockMaterialPartQuery({
    id: partId,
  });

  return (
    <>
      <div>
        <Spinner2 show={isLoading} />
        <Table
          key={`table-${stockMaterialParts?.data.length ?? 0}`}
          keyField="id"
          data={stockMaterialParts?.data ?? []}
          columns={detailsColumns}
          wrapperClasses="parts-detail-table"
          sizePerPage={10}
          page={1}
          totalSize={stockMaterialParts?.count ?? 0}
        />
      </div>
    </>
  );
};
